module.exports = __webpack_public_path__ + "img/madden_prize_breakdown.618cd4f2.png";